import { requestApi } from '~/services/api';

const BASE_URI = '/janus';

export const register = payload => requestApi(`${BASE_URI}/registration/denmark`, payload, 'POST');
